var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:( _obj = {'button--large': _vm.large, 'button--disabled': _vm.disabled }, _obj[("button--" + _vm.buttonType)] = !!_vm.buttonType, _obj ),attrs:{"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }